<template>
  <modal :title="modalTitle" ref="skuModal" :size="'modal-lg'" @save="saveSku(selectedSku)">
    <div class="row row-spacing justify-content-center">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Description</label>
              <input type="text" class="form-control" v-model="selectedSku.description" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>SKU</label>
              <input type="text" class="form-control" v-model="selectedSku.sku" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Markup</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="selectedSku.markup"
                  placeholder="10"
                />
                <div class="input-group-append">
                  <span class="input-group-text">%</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Status</label>
              <v-select :options="['true', 'false']" v-model="selectedSku.status"></v-select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/GeneralComponents/Modal";

export default {
  components: {
    Modal,
  },
  props: {
    modalTitle: {
      type: String,
      required: true,
    },
    selectedSku: {
      type: Object,
      required: true,
    },
    saveText: {
      type: String,
      default: "Save",
    }
  },
  data() {
    return {
      loading: false,
    };
  },
  mounted() {
  },
  methods: {
    open: function () {
      this.$refs.skuModal.open();
    },
    saveSku: function (sku) {
      this.$emit("saveSku", sku);
      this.$refs.skuModal.close();
    },
  },
};
</script>